import React from "react";
import starIcon from "../../assets/images/rating_star_image.png";
import "./FooterSignup.css";

const FooterSignup: React.FC = () => {
  return (
    <footer className="sing-footer">
      <div className="footer-left">
        <p>Copyright © 2025 Claya. All rights reserved.</p>
      </div>
      <div className="footer-right">
        <div className="footer-rating-section">
          <span className="footer-rating">Excellent 4.8</span>
          <img src={starIcon} alt="Rating" />
          <span className="footer-reviews">5.4k+ reviews</span>
        </div>
      </div>
    </footer>
  );
};

export default FooterSignup;
